export enum TradePointFiscalDataTypeEnum {
    FN,
    OFD,
}
